<template>
  <a-spin :spinning="isLoading">
    <div class="leader-project-competencies">
      <h3>{{ title }}</h3>

      <div v-if="description" class="description">
        <p>{{ description }}</p>
      </div>

      <div class="competencies-list">
        <leader-competencies-card
          v-for="(item, index) in competencies"
          :key="item.title"
          :index="index"
          :title="item.title"
          :items="item.items"
        />
      </div>
    </div>
  </a-spin>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import LeaderCompetenciesCard from '@/views/leader/projects/competencies/LeaderCompetenciesCard.vue';

  const api = useApi();
  const competencies = ref([]);
  const isLoading = ref(true);

  defineProps({
    title: String,
    description: String,
  });

  onMounted(async () => {
    await getStats();
    isLoading.value = false;
  });

  const getStats = async () => {
    try {
      const response = await api.checkpointCompetenceSet.performerCompetencies(
        new URLSearchParams({
        })
      );

      competencies.value = [
        {
          title: 'Предметная область',
          items: response.sets.items.map(
            (el) => el.competenceSubject
          ),
        },
        {
          title: 'Технологии',
          items: response.sets.items.map(
              (el) => el.competenceTechnology
          ),
        },
        {
          title: 'Навыки',
          items: response.sets.items.map(
              (el) => el.competenceSkill
          ),
        },
      ];

    } catch (error) {
      console.error('error', error);
    }
  };

  defineExpose({ getStats });
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .leader-project-competencies {
    margin-top: 10px;
    max-width: 902px;

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    h4 {
      font-size: 14px;
      margin: 30px 0 6px;

      &.disabled {
        color: $color-text-primary !important;
      }
    }

    .description {
      color: $color-text-primary;
      display: flex;
      flex-direction: column;
      font-family: 'Nunito Sans', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      gap: 18px;
      line-height: 20px;
      max-width: 678px;
    }
  }
</style>
